import React from "react";
import styles from "./signAndLock.module.scss";

export const ReEvalButton = ({ disabled, onReEval }) => (
  <button className={styles.re_eval} onClick={onReEval} disabled={disabled}>
    Re-Eval
  </button>
);
